/* eslint @typescript-eslint/no-var-requires: "off" */
import * as api from "../../constant/NewAPI";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import Select from "react-select";
import { Link } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";
import Utils from "../../constant/Utils";
import Swal from "sweetalert2";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";


// const api = require("../../constant/API");

const OpsManagerList = () => {

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState("");
    const [managerList, setManagerList] = useState([]);
    const [opsManagerList, setOpsManagerList] = useState([]);
    const [instList, setInstList] = useState([]);
    const [instId, setInstId] = useState("");
    const [mgrId, setMgrId] = useState("");
    const [upDateInstId, setUpdateInstId] = useState("");
    const [updateMgrId, setUpdateMgrId] = useState("");
    const [updateInstName, setUpdateInstName] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);


    const formRef = useRef(null);

    useEffect(() => {
        getManagerList();
        mnagrList();
        // if (roleId == '1' || roleId == '5') {
        instiList();
        // }
    }, [])

    function getManagerList() {
        const getMgrLst = api.adminOpsMgrLst //+ "?userId=" + userId + "&roleId=" + roleId;
        fetch(getMgrLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((lstResponse) => lstResponse.json())
            .then((lstResult) => {
                if (lstResult.error == true) {
                    if (lstResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (lstResult.data != null) {
                        setManagerList(lstResult.data);
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the institution manager list", error)
            })
    }

    function instiList() {
        const getInstList = api.AsignOpsInstList + '/' + roleId //+ "?userId=" + userId + "&roleId=" + roleId;
        fetch(getInstList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((instResponse) => instResponse.json())
            .then((instResult) => {
                if (instResult.error == true) {
                    if (instResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (instResult.data != null) {
                        setInstList(instResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the institution list", error);
            })
    }

    function mnagrList() {
        const getOpsManagerList = api.MgrList;
        fetch(getOpsManagerList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((mgrResponse) => mgrResponse.json())
            .then((mgrResult) => {
                if (mgrResult.error == true) {
                    if (mgrResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (mgrResult.data != null) {
                        setOpsManagerList(mgrResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch list of ops manager list", error);
            })
    }

    function initialVals() {
        setIsEdit(false);
        setOpenModal(true);
        setInstId("")
        setMgrId("")
    }

    function editOps(row) {

        setInstId(row.institutionManagerInstituteId)
        setMgrId(row.institutionManagerOpsId)

        setUpdateInstId(row.institutionManagerInstituteId)
        setUpdateMgrId(row.institutionManagerId)
        setUpdateInstName(row.InstitutionName)
        setIsEdit(true)
        setOpenModal(true)

    }

    function assignOpsManager(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateOpsManager();
            }
            else {
                setIsLoading(true)
                setTimeout(() => {
                    const formData = new FormData();

                    formData.append("insMgrInstituteId", instId)
                    formData.append("insMgrUserId", mgrId)

                    const saveInstOpsMgr = api.SaveInstituteOpsManager;
                    fetch(saveInstOpsMgr, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((saveMgrResponse) => saveMgrResponse.json())
                        .then((mgrResult) => {
                            setIsLoading(false);
                            if (mgrResult.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: mgrResult.message,
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                if (mgrResult.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: mgrResult.message,
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                }, 1000)

            }
            setOpenModal(false)
            // window.location.reload();
        }
    }

    function updateOpsManager() {
        setIsLoading(true)
        setTimeout(() => {
            const formData = new FormData();
            formData.append("insMgrInstituteId", upDateInstId);
            formData.append("insMgrUserId", mgrId);
            formData.append("insMgrId", updateMgrId);

            const updateInstOpsMgr = api.UpdateInstituteOpsManager;
            fetch(updateInstOpsMgr, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((updateResponse) => updateResponse.json())
                .then((result) => {
                    setIsLoading(false);
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                window.location.reload(); // 🔁 Reload only after OK is clicked
                            }
                        });
                    }
                })
                .catch((error) => {
                    console.log("Failed to update the Ops Manager!", error);
                })
        }, 1000)

    }

    const filteredData = managerList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value?.toString().toLowerCase() ?? ""
        );
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });


    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editOps(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const instituteRender = (rowData) => {
        return <span>{rowData.InstitutionName}</span>
    }

    const mgrRender = (rowData) => {
        return <span>{rowData.ManagerName}</span>
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col-sm-12">
                    <div className="court-tab-content">
                        <div className="card card-tableset">
                            <div className="card-body">
                                <div className="coache-head-blk">
                                    <div className="row align-items-center">
                                        {(roleId == '1'|| roleId == '3') ? (
                                            <>
                                                <div className="row col-lg-12">
                                                    <div className="col-lg-4">
                                                        <Link
                                                            to="#"
                                                            className="btn btn-secondary"
                                                            onClick={initialVals}
                                                        >
                                                            <i className="fas fa-check" />&nbsp;
                                                            Assign Ops Manager
                                                        </Link>
                                                    </div>
                                                </div>
                                            </>
                                        ) : null}
                                        <div className="col-md-6">
                                        </div>
                                        <div className="col-md-6">
                                            <div className="dataTables_filter">
                                                <label>
                                                    <input
                                                        type="text"
                                                        value={searchInput}
                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                        placeholder="Search"
                                                        className="form-control"
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50]}
                                                currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="InstitutionName"
                                                    body={instituteRender}
                                                    header="Institute"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="ManagerName"
                                                    header="Ops Manager"
                                                    body={mgrRender}
                                                ></Column>
                                                {(roleId == '1') ? (
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                ) : null}
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Assign Ops Manager */}

            {openModal && (
                <Modal
                    show={openModal}
                    size="md"
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case"><i className="fas fa-check" />{isEdit ? "Edit " : "Assign "}Ops Manager</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => setOpenModal(false)}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            {
                                !isEdit ?
                                    <div className="mb-10">
                                        <label className="form-label">Institute</label>
                                        <Select
                                            value={instList.find(ins => ins.institutionId === instId) ? {
                                                value: instId,
                                                label: instList.find(ins => ins.institutionId === instId).institutionName
                                            } : null}
                                            required
                                            onChange={(e) => {
                                                setInstId(e.value);
                                            }}
                                            placeholder="Select Institute"
                                            options={instList.map(ins => ({
                                                value: ins.institutionId,
                                                label: ins.institutionName
                                            }))}>
                                        </Select>
                                    </div>
                                    : null
                            }
                            {
                                isEdit ?
                                    <div className="mb-10">
                                        <label className="form-label">Institute</label>
                                        <input
                                            id="instituteName"
                                            className="form-control"
                                            style={{ border: "1px solid hsl(0, 0%, 80%)", backgroundColor: "#e9ecef" }}
                                            value={updateInstName}
                                            placeholder="Institution Name"
                                            required
                                            readOnly
                                        />
                                    </div>
                                    : null
                            }
                            <div className="mb-10">
                                <label className="form-label">Operations Manager</label>
                                <Select
                                    value={opsManagerList.find(ops => ops.internalUserId === mgrId) ? {
                                        value: mgrId,
                                        label: opsManagerList.find(ops => ops.internalUserId === mgrId).internalUserFirstName + " " +
                                            opsManagerList.find(ops => ops.internalUserId === mgrId).internalUserLastName
                                    } : null}
                                    required
                                    onChange={(e) => {
                                        setMgrId(e.value);
                                    }}
                                    placeholder="Select Manager"
                                    options={opsManagerList.map(ops => ({
                                        value: ops.internalUserId,
                                        label: ops.internalUserFirstName + " " + ops.internalUserLastName
                                    }))}>
                                </Select>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn-primary text-uppercase"
                            variant="success"
                            onClick={assignOpsManager}
                            data-bs-dismiss="modal" aria-label="Close"
                        >
                            <b><i className="fas fa-save" />Save</b>
                        </Button>
                    </ModalFooter>
                </Modal>
            )}
            {/* /Assign Ops Manager */}

        </>
    );
}

export default OpsManagerList;